import { IProduct } from 'src/common/types/CatalogType';
import {
  getEnvironment,
  getPrice,
  addOneToPosition,
  parseListName,
} from 'src/services/googleAnalytics/enhancedEcommerce/helpers';
import {
  EnhancedEcommerceEvents,
  IEnhancedEcommerceEvent,
  IEnhancedEcommerceProduct,
} from 'src/services/googleAnalytics/enhancedEcommerce/types';

export type IProductWithPosition = IProduct &
  Pick<Required<IEnhancedEcommerceProduct>, 'position'>;

const parseProducts = (
  products: IProductWithPosition[],
  catalogPages: number[],
): IEnhancedEcommerceProduct[] =>
  products.map((product) => ({
    brand: product.brand,
    category: product.category,
    id: product.sku,
    name: product.name,
    price: getPrice(product.price, product.discountPrice),
    position: addOneToPosition(product.position),
    list: parseListName(catalogPages),
  }));

export const sendProductImpressionsEvent = (
  products: IProductWithPosition[],
  catalogPages: number[],
) => {
  const parsedProducts = parseProducts(products, catalogPages);

  if (!parsedProducts.length) {
    return;
  }

  const productImpressionsEvent: IEnhancedEcommerceEvent = {
    event: EnhancedEcommerceEvents.productImpressions,
    // TODO: remove getEnvironment helper and replace it by common content variables;
    ambiente: getEnvironment(process.env.BRAND_IDENTIFIER),
    ecommerce: {
      impressions: parsedProducts,
    },
  };
  window.dataLayer.push(productImpressionsEvent);
};
